require('./mortgageRequestHolderEconomicAnotherLoan.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const OKStatusIcon = require('components/commons/OKStatusIcon/OKStatusIcon');
const { OKButton } = require('components/commons/OKButton/OKButton');
const Modal = require('./modal');

// @ constants
const {
    PEND_VAL,
    VERIFICADO,
    NO_VALIDO,
    PEND_RESP_OCR
} = require('constants/mortgageRequestHolderData').DOCUMENTS_STATUS;
const { HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER } = require('constants/flagBasedFeatures');

const LOAN_TYPES_TITLE = {
    PERSONAL_LOAN: 'mortgageRequestHolderEconomic-anotherLoanTitlePersonal',
    MORTGAGE: 'mortgageRequestHolderEconomic-anotherLoanTitleMortgage'
}
const { OTHER_LOANS_TYPES } = require('constants/mortgageRequestHolderData');

class MortgageRequestHolderEconomicAnotherLoan extends React.Component {
    constructor() {
        super();
        this.state = {
            confirmRemoveLoan: false
        }

        this.handleRemove = this.handleRemove.bind(this);
        this.cancelRemoveLoan = this.cancelRemoveLoan.bind(this);
        this.confirmRemoveLoan = this.confirmRemoveLoan.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
    }

    buildAmountToPayContent(immAnotherLoan) {
        const amountToPay = immAnotherLoan.get('amountToPay');

        let amountToPayContent;

        if (!!amountToPay) {
            const formattedAmountToPay = MortgageRequestCurrencyHelp({ currency: immAnotherLoan.get('amountToPay') });

            amountToPayContent = (
                <div className="mortgage-request-holder-economic-another-loan__amount">
                    <FormattedText value="mortgageRequestHolderEconomic-labelAmountToPay" />
                    <span className="mortgage-request-holder-economic-another-loan__amount-value">{formattedAmountToPay}</span>
                </div>
            );
        }

        return amountToPayContent;
    }

    cancelRemoveLoan() {
        this.setState({ confirmRemoveLoan: false });
    }

    configModalOptions(immAnotherLoan) {
        let title = formatText('mortgageRequestHolderEconomic-deleteMortgageTitle');
        let body = formatText('mortgageRequestHolderEconomic-areYouSureText');

        if (immAnotherLoan.get('type') === OTHER_LOANS_TYPES.PERSONAL_LOAN) {
            title = formatText('mortgageRequestHolderEconomic-deleteLoanTitle');
            body = formatText('mortgageRequestHolderEconomic-areYouSureTextLoan');
        }

        const config = {
            handlers: {
                handleClose: this.cancelRemoveLoan,
                handleClickBtn: this.confirmRemoveLoan
            },
            text: {
                title,
                body,
                cancelButton: formatText('mortgageRequestHolderEconomic-cancelButtonLabel'),
                confirmButton: formatText('mortgageRequestHolderEconomic-confirmButtonLabel')
            }
        };

        return config;
    }

    confirmRemoveLoan() {
        const { deleteOtherLoan, immAnotherLoan } = this.props;

        const loanData = {
            documentNumber: immAnotherLoan.get('documentNumber'),
            documentType: immAnotherLoan.get('documentType'),
            id: immAnotherLoan.get('id')
        };

        deleteOtherLoan(loanData);
    }

    handleEdit() {
        const { immAnotherLoan, onEditAnotherLoan } = this.props;

        onEditAnotherLoan(immAnotherLoan);
    }

    handleRemove() {
        this.setState({ confirmRemoveLoan: true });
    }

    buildLinkDocument() {
        const { documentLink, handleDownload, immFlagBasedFeatures } = this.props;
        const ffHideUpload = !(immFlagBasedFeatures.get(HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER));
        return ffHideUpload && (
            <div className="mortgage-request-holder-economic-another-loan__document">
                <OKButton modifier="link-complementary" onClick={handleDownload}>
                    {documentLink}
                </OKButton>
            </div>
        )
    }

    render() {
        const { immAnotherLoan, counter, documentStatus, holderEconomic } = this.props;

        const titleKey = LOAN_TYPES_TITLE[immAnotherLoan.get('type')];
        const formattedPendingAmount = MortgageRequestCurrencyHelp({ currency: immAnotherLoan.get('pendingAmount') });
        const statusIcon = OKStatusIcon({
            status: documentStatus,
            wrapperClasses: "mortgage-request-holder-economic-another-loan__title--icon",
        });
        const amountToPayContent = this.buildAmountToPayContent(immAnotherLoan);
        let modal = '';

        if (this.state.confirmRemoveLoan) {
            const isDeleting = holderEconomic.get('isDeletingOtherLoan');
            const modalOptions = this.configModalOptions(immAnotherLoan);
            modal = <Modal config={modalOptions} isDeleting={isDeleting} />
        }
        const holderEconomicIsConfirmed = holderEconomic.get('confirmada');

        const removeIconIsDisabled = holderEconomicIsConfirmed &&
        (documentStatus === PEND_RESP_OCR || documentStatus === PEND_VAL || documentStatus === VERIFICADO);
        const editButtonEnabled = !holderEconomicIsConfirmed || documentStatus === NO_VALIDO;

        return (
            <div className="mortgage-request-holder-economic-another-loan">
                <div className="mortgage-request-holder-economic-another-loan__title">
                    <FormattedText value={titleKey} injectedStrings={[counter]} />
                    {statusIcon}
                </div>
                <div className="mortgage-request-holder-economic-another-loan__amount">
                    <FormattedText value="mortgageRequestHolderEconomic-labelPendingAmount" />
                    <span className="mortgage-request-holder-economic-another-loan__amount-value">{formattedPendingAmount}</span>
                </div>
                {amountToPayContent}
                <div className="mortgage-request-holder-economic-another-loan__buttons">
                    <div className="mortgage-request-holder-economic-another-loan__buttons-edit">
                        <OKButton
                            size="small"
                            modifier="task"
                            onClick={this.handleEdit}
                            disabled={!editButtonEnabled}
                        >
                            <i className="icon-editar" />
                        </OKButton>
                    </div>
                    <div className="mortgage-request-holder-economic-another-loan__buttons-remove">
                        <OKButton
                            size="small"
                            modifier="task"
                            onClick={this.handleRemove}
                            disabled={removeIconIsDisabled}
                        >
                            <i className="icon-eliminar" />
                        </OKButton>
                    </div>
                </div>
                {this.buildLinkDocument()}
                {modal}
            </div>
        );
    }

}

MortgageRequestHolderEconomicAnotherLoan.propTypes = {
    immAnotherLoan: PropTypes.object.isRequired,
    counter: PropTypes.number.isRequired,
    documentStatus: PropTypes.string.isRequired,
    documentLink: PropTypes.string.isRequired,
    handleDownload: PropTypes.func.isRequired,
    deleteOtherLoan: PropTypes.func.isRequired,
    holderEconomic: PropTypes.object.isRequired,
    onEditAnotherLoan: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object,
}

module.exports = MortgageRequestHolderEconomicAnotherLoan;
